import { FOOTER_1_CONSTANTS } from "./footer_1";

const F1 = FOOTER_1_CONSTANTS.FOOTER_FIELDS_CONFIG;
const CAT = FOOTER_1_CONSTANTS.CATEGORY_FIELDS_CONFIG;
const T = FOOTER_1_CONSTANTS.FOOTER_TABLE_FIELDS_CONFIG;

/** Footer 3 — `column_count` and per-category `column_index` are 1-based (first column = 1). */
export const FOOTER_3_CONSTANTS = {
  FOOTER_FIELDS_CONFIG: [
    F1[0],
    {
      fieldName: "column_count",
      label: "Number of columns",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Total columns (integer ≥ 1)",
      required: true,
    },
    ...F1.slice(1),
  ],

  CATEGORY_FIELDS_CONFIG: [
    CAT[0],
    {
      fieldName: "column_index",
      label: "Column number (≤ column count)",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "1 = first column (1-based; must be ≤ column count)",
      required: true,
      defaultValue: 1,
    },
    ...CAT.slice(1),
  ],

  /** Same as Footer 1 link rows, plus optional icon for social / branded links (variant 3). */
  FOOTER_TABLE_FIELDS_CONFIG: [
    T[0],
    {
      header: "Link icon",
      fieldName: "icon_url",
      label: "Link icon / logo",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon (e.g. social logo)",
      required: false,
      defaultValue: "",
      description:
        "If you add an image here, it is shown in the link instead of the text label. The text label is still used as a fallback for accessibility when icon alt text is empty.",
    },
    {
      header: "Icon alt text",
      fieldName: "icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the icon for screen readers",
      required: false,
      defaultValue: "",
    },
    ...T.slice(1),
  ],
};
